function getHeight(){
    let block = $(".menu-nav--featured-block");
    $(block).each(function(){
        let imageHeight = $(this).height();
        $(".menu-nav--featured-block--image-wrapper", this).css("height", imageHeight);
    });
};
function getWidth(){
    let navWidth = $(".mega-nav--menu-wrap").width();
    let windowWidth = $(window).width();
        $(".mega-nav--menu-wrap").css("width", windowWidth);
}
// getHeight();
getWidth();
$(window).resize(function(){
    // getHeight();
    getWidth();
});

$(`.global-nav--menu--nav_menu_one`).on(`mouseover`, (e) => {
    const $target = $(e.currentTarget);
    $target.find(`img[data-src], img[data-srcset]`).each((idx, image) => {
        if (image.classList.contains(`lazy`)) return;
        image.classList.add(`lazy`);
    });

    if (!myLazyLoad) return;
    myLazyLoad.update();
});